import script from "./TheTable.vue?vue&type=script&setup=true&lang=js"
export * from "./TheTable.vue?vue&type=script&setup=true&lang=js"

import "./TheTable.vue?vue&type=style&index=0&id=0a4dd0fc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a4dd0fc"]])

export default __exports__